import { MagnifyingGlassIllustration } from '../../assets/illustrations';
import { Headings } from '../Headings';
import { Flex } from '../Layout';
import { Link } from '../Link';
import { Text } from '../Text';
import { ErrorPageProps } from './ErrorPage';

export const ErrorPage404 = ({ title, message, links }: ErrorPageProps) => {
  return (
    <>
      <Headings.H1>{title || 'Sidan kan inte hittas'}</Headings.H1>
      <MagnifyingGlassIllustration width={[180, 180, 220]} />
      <Text size="large" textAlign="center">
        {message || 'Vänligen kontakta Foras kundservice för mer information på 08-787 40 10.'}
      </Text>
      <Flex flexDirection="column" rowGap={20}>
        {links &&
          links.map(({ linkText, linkUrl }, index) => {
            return (
              <Link to={linkUrl} key={index} fontSize="large">
                {linkText}
              </Link>
            );
          })}
      </Flex>
    </>
  );
};
